import React from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import moment from 'moment'
import { cn } from '~/lib/utils'
import { Button } from '~/lib/ui/button'
import { useBenefits } from '../BenefitsProvider'

export default function CalendlyEventInfo({
  eventName,
  calendlyEvent,
  dashboardCard,
  introCallScheduled,
  linkColor,
}) {
  const { t } = useTranslation()
  const { onCancelClick, select } = useBenefits()

  const { start_time, join_url, reschedule_url, cancel_url } = calendlyEvent
  return (
    <div>
      {!introCallScheduled && (
        <>
          <div className="font-bold">
            {eventName} {t('service_card.scheduled')}
          </div>
          <div>{moment(start_time).format('MMMM Do YYYY, h:mm a')}</div>
        </>
      )}
      <div className="flex items-center gap-4 pt-4">
        <a
          href={join_url}
          target="_blank"
          rel="noopener noreferrer"
          className={cn('', dashboardCard ? 'flex-grow' : '')}
        >
          <Button
            variant={select ? 'outline' : 'coachcta'}
            target="_blank"
            rel="noopener noreferrer"
            className={cn('', dashboardCard ? 'w-full' : '')}
          >
            {t('service_card.join_meeting')}
          </Button>
        </a>
        <a
          href={reschedule_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onCancelClick()}
          className={cn(linkColor, 'hover:!underline')}
        >
          {t('service_card.reschedule')}
        </a>
        <a
          href={cancel_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onCancelClick()}
          className={cn(linkColor, 'hover:!underline')}
        >
          {t('service_card.cancel')}
        </a>
      </div>
    </div>
  )
}
